import {Form, Formik} from 'formik'
import {isEmpty} from 'lodash'
import {useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {toast} from 'react-toastify'
import Modal from 'rsuite/Modal'
import {StateParamsModel} from 'src/app/modules/common/Model'
import FormTextBox from 'src/cms/helpers/components/forms/FormTextBox'
import * as Yup from 'yup'
import {safeText} from 'src/cms/helpers/validation/safeText'
import {KeyModel} from '../Model'
import * as key from '../index'

type Props = {
  open: boolean
  params?: StateParamsModel
  handleClose: () => void
  actionType: string
  editSelectedData?: any
}

const AddKey = ({open, params, handleClose, actionType, editSelectedData}: Props) => {
  const dispatch = useDispatch()
  const {loading, success} = useSelector((state: any) => state.key)

  const FORM_VALIDATION = Yup.object().shape({
    name: safeText().required('Name is required'),
    key: Yup.string().required('Key is required'),
  })

  useEffect(() => {
    if (success) {
      dispatch(key?.actions.getKey(params))
      isEmpty(editSelectedData)
        ? toast.success('KEY added successfully')
        : toast.success('KEY edited successfully')
      dispatch(key?.actions?.createKeyReset())
      handleClose()
    }
  }, [success])

  return (
    <div className='modal-container' data-cy='modal-add-key-container'>
      <Modal
        open={open}
        onClose={handleClose}
        backdrop='static'
        keyboard={false}
        enforceFocus={false}
        data-cy='modal'
      >
        <Modal.Header>
          <Modal.Title data-cy='modal-title'>{actionType} KEY Settings</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <Formik
              initialValues={{
                name: '',
                key: '',
              }}
              validationSchema={FORM_VALIDATION}
              onSubmit={(values: KeyModel, {setSubmitting}) => {
                if (!isEmpty(editSelectedData)) {
                  dispatch(key.actions.updateKey(values, editSelectedData?.id))
                } else {
                  dispatch(key.actions.createKey(values))
                }
              }}
              data-cy='modal-add-key-header'
            >
              {({isSubmitting, touched, handleChange, errors, values, setFieldValue}) => {
                useEffect(() => {
                  if (!isEmpty(editSelectedData)) {
                    const fields = ['name', 'key']
                    fields.forEach((field) => setFieldValue(field, editSelectedData[field], false))
                  }
                }, [])

                return (
                  <Form>
                    <div className='card-body border-top pt-5' data-cy='card-add-key'>
                      <FormTextBox
                        containerClassName='col-lg-8 '
                        type='text'
                        placeholder='Name '
                        label='Name'
                        name='name'
                        onChange={handleChange}
                        errors={errors}
                        touched={touched}
                        required={true}
                        data-cy='modal-add-key-name-field'
                      />

                      <FormTextBox
                        containerClassName='col-lg-8 '
                        type='text'
                        placeholder='Key'
                        label='Key'
                        name='key'
                        onChange={handleChange}
                        errors={errors}
                        touched={touched}
                        required={true}
                        data-cy='modal-add-key-key-field'
                      />
                    </div>

                    <div className='d-flex justify-content-end px-9 '>
                      <button
                        type='submit'
                        disabled={loading}
                        className='btn btn-primary btn-sm ms-3'
                        data-cy='modal-submit'
                      >
                        Save
                      </button>
                      <button
                        type='button'
                        onClick={handleClose}
                        className='btn btn-secondary btn-sm ms-3'
                        data-cy='modal-cancel'
                      >
                        Cancel
                      </button>
                    </div>
                  </Form>
                )
              }}
            </Formik>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  )
}
export default AddKey
